<template>
    <a-card size="small" title="运维创建">
        <a-button type="primary" slot="extra" @click="handleNew">新建</a-button>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
            <a-form-model-item  label="所属领域">
                <a-select show-search placeholder="请选择" style="width: 120px" allow-clear v-model="searchP.level">
                    <a-select-option v-for="(value,name) in levelData" :key="name" :value="name">
                    {{value}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item  label="svn目录">
                <a-select show-search placeholder="请选择" style="width: 120px" allow-clear v-model="searchP.svn">
                    <a-select-option v-for="(value,name) in svnData" :key="name" :value="name">
                    {{value}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-item label="域名">
                <a-input v-model="searchP.domain" placeholder="请输入域名关键字"></a-input>
            </a-form-item>
            <a-form-item label="项目名">
                <a-input v-model="searchP.projectname" placeholder="请输入项目名关键字"></a-input>
            </a-form-item>
           
            <a-form-item>
                <a-button type="primary" @click="getAppSumData">查询</a-button>
            </a-form-item>

             <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
            </a-form-item>

            <a-popover title="使用说明" trigger="click">
                <template #content>
                    <p>1、Java后端项目，会在各测试环境中自动创建“项目名_master_1 ” Redis Shard 和 “topic_项目名 ”MQ Topic。</p>
                    <p>2、如果项目需要外部域名访问，就填下域名。按域名+环境名.cnzhonglunnet.com 约定， 会在各测试环境nginx服务器中自动创建。</p>
                    <p>3、后端项目位于JT和Java SVN目录， 其余项目为前端项目。</p>
                    <p>4、后端项目，需要指定所属的领域</p>
                    <p>5、目前此申请只是针对测试环境。</p>
                </template>
                <a-button type="link" class="mt2">使用说明</a-button>
            </a-popover>
        </a-form>
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="tableData" class="mt20" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">
            <!-- 报文 -->
            <template slot="statusP" slot-scope="text,record">
                <a-tag :color="JSON.parse(text).svn ? 'green' : 'red'">svn</a-tag>
                <a-tag v-if="record.svn == 'JT' || record.svn == 'Java'" :color="JSON.parse(text).redis ? 'green' : 'red'">redis</a-tag>
                <a-tag v-if="record.svn == 'JT' || record.svn == 'Java'" :color="JSON.parse(text).mq ? 'green' : 'red'">mq</a-tag>
                <a-tag v-if="record.domain" :color="JSON.parse(text).site ? 'green' : 'red'">site</a-tag>
            </template>

            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a-button v-if="record.status.indexOf('false') != 0 && G.isUserAdmin()" type="link" @click="handleProcess(record)">运维创建</a-button> 
                <span>
                    <a-button type="link" @click="handleEdit(record)">编辑</a-button> 
                
                </span>
                <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                            <a  href="javascript:;">删除</a>
                </a-popconfirm>
                </div>
            </template>
            
        </a-table>
        <a-pagination class="my_pagenation" v-model="pagination.page" :total="pagination.total" @change="handlePageChange"
                      show-less-items show-quick-jumper/>

        <itemModal :svnData="svnData" :levelData="levelData" ref="myItemModal" @onModalHide="onModalHide"></itemModal>
    </a-card>
</template>
<script>
import itemModal  from './item.vue'
import $ from 'jquery'

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
let svnData = {
    'JT':'JT',
    'Java':'Java',
    'MT':'MT',
    'MWeb':'MWeb',
    'PCWeb':'PCWeb',
    'TWeb':'TWeb'

}
let levelData = {
    'qt':'前台',
    'zt':'中台',
    'jt':'基础',
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    { 
        title: '项目名称', 
        dataIndex: 'projectname',
        align:'center',
        width:100, 
    },
    {
        title: 'SVN目录',
        dataIndex: 'svn', 
        align:'center',
        customRender: (text) => {
            return svnData[text]
        },
        width:100
    },
    {
        title: '所属领域',
        dataIndex: 'level', 
        align:'center',
        customRender: (text) => {
            return levelData[text]
        },
        width:100
    },
    { 
        title: '域名',
        dataIndex: 'domain',
        align:'center',
        width:200,
    },

    {
        title: '状态',
        dataIndex: 'status', 
        align:'center',
        scopedSlots: { customRender: 'statusP' },
        width:200
    },
    {
        title: '创建时间',
        dataIndex: 'createtime', 
        align:'center',
        width:180
    },

    {
        title: '创建人',
        dataIndex: 'createuser', 
        align:'center',
        width:100
    },
    {
        title: '更新时间',
        dataIndex: 'updatetime', 
        align:'center',
        width:180
    },
    {
        title: '更新人',
        dataIndex: 'updateuser', 
        align:'center',
        width:100
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        fixed:'right',
        scopedSlots: { customRender: 'operation' },
    }

];
export default {
    components:{
        itemModal
    },
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            svnData,
            levelData,
            tableData:[],
            tloading:false,
            clientWidth:800,
            pagination,
            searchP:{
                domain:'',
                projectname:'',
                svn:'',
                level:'',

            },
        };
    },
    methods: {
        //运维创建
        handleProcess(record){
            let that = this;
            this.tloading = true;
            $.ajax({
                url:'http://192.168.1.10:8080/applyProject ',
                method:'POST',
                dataType: 'json', //指定数据返回格式
                contentType : "application/json", //发送至服务器的类型

                data: JSON.stringify({
                    name:record.projectname,
                    level:record.level,
                    svnClass:record.svn,
                    dnsName:record.domain,
                }),
                // xhrFields: {
                //     withCredentials: false, //跨域下使用
                // },
                success: function (data) {
                    console.log(data);
                    that.updateRecord(JSON.stringify(data),record.id)
                },
                error: function (error) {
                    console.log(error)
                    that.tloading = false;
                },
            })
        },
        updateRecord(statusStr,id){
            let that = this;
            that.$store.dispatch({
                type: 'project/edit',
                params: {
                    id:id,
                    status:statusStr,
                    updateuser:that.G.getCurrentUser().username,
                    urlparams:false,
                }
            }).then((res) => {
                that.tloading = false;
                if (res.data.success == '1') {
                    this.getAppSumData();
                }
            });
        },
        //删除
        onDelete(record) {
            this.$store.dispatch({
                type: "project/delete",
                params: record
            }).then(() => {
                this.pagination.page = 1;
                this.getAppSumData();
            });
        },
        onModalHide(){
            this.getAppSumData();
        },
        handleEdit(record){
            this.$refs.myItemModal.init({
                ...record
            })
        },
        handleNew(){
            this.$refs.myItemModal.init({
                id:''
            })
        },
        handleSearchReset(){
            this.searchP = {
                domain:'',
                projectname:'',
                svn:'',
                level:'',
            }
            this.pagination.page = 1;
            this.getAppSumData()
        },
        handlePageChange(c_p) {
            this.pagination.page = c_p;
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            that.tloading = true
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'project/query',
                params:params
            }).then((res)=>{
                that.tloading = false;
                let result = res.data.data;
                that.tableData = result.list;
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.page = result.page;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(){
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },
    mounted(){
        this.pagination.page = 1;
        this.getAppSumData()
        //如果是跳转过来，打开对话框新建
        const {query} = this.$route;
        if(query.syscode){
            this.handleNew()
        }
    }
};
</script>
